import Joi from 'joi';
import { rutValidation } from '../../../../../../helpers/RutValidator';
import JoiDate from '@hapi/joi-date';

export const schema = Joi.object({
  motiveClient: Joi.string()
    .min(3)
    .error(new Error('Debe ingresar una opción')),
  rut: rutValidation.rut().validateRut(),
  purchaseDate: Joi.extend(JoiDate)
    .date()
    .format('YYYY-MM-DD')
    .error(new Error('Formato de fecha inválido')),
  clientName: Joi.string()
    .min(3)
    .error(new Error('Debe ingresar su nombre completo.')),
  phone: Joi.string()
    .min(9)
    .max(9)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('El teléfono debe contener 9 dígitos.')),
  email: Joi.string()
    .email({ minDomainSegments: 2, tlds: {} })
    .error(new Error('Formato de correo inválido.')),
  comment: Joi.string()
    .min(5)
    .max(200)
    .error(new Error('Máximo 200 caracteres.')),
});
